import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

interface EcosystemFeatureProps {
  textKey: string;
  index: number;
}

export const EcosystemFeature: React.FC<EcosystemFeatureProps> = ({ textKey, index }) => {
  const { t } = useTranslation('platform');

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.15,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.li
      variants={itemVariants}
      className="flex items-start gap-4"
    >
      <div className="flex-shrink-0 mt-1">
        <Star size={22} className="text-amber-500" fill="currentColor" />
      </div>
      <p className="text-lg text-slate-700 leading-relaxed">
        {t(textKey)}
      </p>
    </motion.li>
  );
};

